<template>
  <!--srcviewscompanylistriskvuehtmlStart-->
  <div>
    <div id="defaultId1" class="uedbd2 pb20" v-loading="RiskLoding">
      <div
        id="cc5f49"
        :class="
          $store.state.app.isMenu
            ? 'scrollbar no_menu_scrollbar_right'
            : ' scrollbar no_menu_scrollbar_right udb507two'
        "
        v-show="!Compare"
      >
        <div style="height: 100%">
          <div class="list-label" style="height: 100%">
            <div
              id="c6d65e"
              class="ub7918 Alchecked flex_center_bettwen"
              style="padding-left: 20px; align-items: center"
            ></div>

            <h3 class="operations-head-content">
              <div style="display: flex; align-items: center">
                <span class="operations-head font1A2332 font_bold">{{
                  $t("SearchTrade.SimilarProducts")
                }}</span>
                <span class="tptitleSplit">|</span>
                <span class="font_bold product_title"
                  >{{ $t("SearchTrade.Numberofsimilarproducts") }}:<span
                    class="font_bold"
                    style="color: #009ea7; margin-left: 5px;font-size: 20px;"
                    >{{ page.total }}</span
                  >
                </span>
              </div>
            </h3>
            <div
              class="flex_center_between_box"
              style="width: 100%; height: 98%"
            >
              <div class="risk-center-list">
                <div>
                  <ul>
                    <draggable
                      filter=".forbid"
                      v-model="CompanyList"
                      :disabled="disabled"
                      animation="300"
                      :move="onMove"
                    >
                      <transition-group>
                        <li
                          v-for="(item, index) in CompanyList"
                          :key="index"
                          class="conpany-center-list forbid item"
                          :class="{
                            iconbgActiveBG: NationalIndustryActive == index,
                          }"
                        >
                          <div
                            class="flex_between_box"
                            style="align-items: center"
                          >
                            <div
                              class="conpany-center-list-left productInfp"
                              :class="
                                NationalIndustryShow
                                  ? 'conpany-center-list-leftWith'
                                  : 'conpany-center-list-left'
                              "
                            >
                              <el-checkbox
                                id="cee084"
                                v-if="isOpenSlct"
                                style="margin-right: 10px; margin-top: 0.3rem"
                                v-model="item.isChecked"
                                label
                                @change="changeItemChecked"
                              >
                              </el-checkbox>
                              <span
                                :class="
                                  item.isDing
                                    ? 'indexPositon'
                                    : 'indexPositonactive'
                                "
                                >{{ index + 1 }}</span
                              >
                              <div
                                :class="{
                                  detailcontent1:
                                    NationalIndustryShow &&
                                    NationalIndustryActive == index,
                                  detailcontent: !(
                                    NationalIndustryShow &&
                                    NationalIndustryActive == index
                                  ),
                                }"
                              >
                                <p class="flex_center_start productTitle">
                                  <span
                                    @click="GotoProducts(item)"
                                    :class="{
                                      Priduct_Name: NationalIndustryShow,
                                    }"
                                    class="font_bold productsNameActive overexperise"
                                    >{{ item.products }}</span
                                  >
                                </p>

                                <p class="list-text-color">
                                  <span
                                    :class="{
                                      overexperise: 1,
                                    }"
                                  >
                                    <span class="font666666 CodeMargin">
                                      {{ $t("SearchTrade.HSCode") }}:</span
                                    >
                                    <span> {{ item.hsCode }}</span>
                                    <span class="fontDDDDDD">|</span>
                                    <span class="font666666 CodeMargin"
                                      >{{ $t("SearchTrade.ProductCode") }}:
                                    </span>
                                    <span>{{ item.productCode }} </span>
                                    <span class="fontDDDDDD">|</span>
                                    <span class="font666666 CodeMargin"
                                      >{{
                                        $t("SearchTrade.ProductDescription")
                                      }}:
                                    </span>
                                    <span class="overexperise"
                                      >{{ item.productDescription }}
                                    </span>
                                  </span>
                                </p>
                                <p class="list-text-color">
                                  <span
                                    class="flex_center"
                                    style="justify-content: flex-start"
                                    :class="{
                                      overexperise: NationalIndustryShow,
                                    }"
                                  >
                                    <span class="CodeMargin font666666">
                                      {{
                                        $t("SearchTrade.TopImportCountries")
                                      }}:</span
                                    >
                                    <div class="flagDiv">
                                      <span
                                        style="margin: 0"
                                        v-for="(
                                          value, ind
                                        ) in item?.destinationCountryList"
                                        :key="value.countryCode"
                                      >
                                        <el-popover
                                          placement="top"
                                          trigger="hover"
                                          style="margin: 0"
                                          popper-class="table_popover"
                                          :content="value.countryName"
                                        >
                                          <img
                                            slot="reference"
                                            class="contry_img"
                                            :src="value.flag"
                                          />
                                        </el-popover>
                                      </span>
                                    </div>

                                    <span class="fontDDDDDD Lmargin">|</span>

                                    <span class="font666666 CodeMargin">
                                      {{
                                        $t("SearchTrade.TopExportCountries")
                                      }}:</span
                                    >

                                    <div class="flagDiv">
                                      <span
                                        style="margin: 0"
                                        v-for="(
                                          value, inde
                                        ) in item?.originCountryList"
                                        :key="inde"
                                      >
                                        <el-popover
                                          placement="top"
                                          trigger="hover"
                                          style="margin: 0"
                                          popper-class="table_popover"
                                          :content="value.countryName"
                                        >
                                          <img
                                            slot="reference"
                                            class="contry_img"
                                            :src="value.originflag"
                                          />
                                        </el-popover>
                                      </span>
                                    </div>
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div class="conpany-center-list-right">
                              <p>
                                <el-popover
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  :content="
                                    $t('SearchTrade.TradeHistoryandTrends')
                                  "
                                >
                                  <span
                                    slot="reference"
                                    class="margin20 iconbg flex_center"
                                    :class="{
                                      iconbgActive:
                                        NationalIndustryActive == index,
                                    }"
                                  >
                                    <i
                                      v-if="NationalIndustryActive == index"
                                      @click="NationalIndustry(item, index)"
                                      class="iconfont icon-qushi"
                                      style="color: #ffffff"
                                    ></i>
                                    <i
                                      v-else
                                      @click="NationalIndustry(item, index)"
                                      class="iconfont icon-qushi"
                                      style="color: #009ea7"
                                    ></i>
                                  </span>
                                </el-popover>
                              </p>
                            </div>
                          </div>
                        </li>
                      </transition-group>
                    </draggable>
                  </ul>
                  <div
                    class="ShowAll flex_center font18 margin-top20"
                    v-if="page.pageSize < page.total"
                    @click="ShowAll"
                  >
                    {{ $t("SearchTrade.ShowAll") }}
                  </div>
                  <div
                    :class="{
                      marginbottom500: NationalIndustryShow,
                    }"
                  ></div>
                </div>

                <div
                  class="risk-right"
                  v-if="NationalIndustryShow"
                  :style="{ marginTop: calculateMarginTop() + 'px' }"
                >
                  <div
                    class="flex_center_between_box"
                    style="margin-bottom: 20px"
                  >
                    <p style="font-family: Arial Bold; margin-bottom: 0px">
                      {{ $t("SearchTrade.TradeHistoryandTrends") }}
                    </p>
                    <div class="flex_center">
                      <svg
                        t="1733120402127"
                        @click="rifghtUpdate()"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="14841"
                        width="1.5714285714285714rem"
                        height="1.5714285714285714rem"
                      >
                        <path
                          d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                          fill="#1A2332"
                          p-id="14842"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <!-- <el-date-picker
                    v-model="datePicker"
                    style="width: 300px; height: 36px"
                    @change="getgetTradeTrends()"
                    type="monthrange"
                    range-separator=""
                    :start-placeholder="$t('SearchTrade.Startdate')"
                    value-format="yyyy-MM"
                    :end-placeholder="$t('SearchTrade.Enddate')"
                  ></el-date-picker> -->

                  <div>
                    <div v-show="false">{{ calDate }}</div>
                    <el-date-picker
                      class="trade_date_picker"
                      v-model="beginDate"
                      type="month"
                      :placeholder="$t('SearchTrade.Startdate')"
                      value-format="yyyy-MM"
                      :picker-options="beginPickerOptions"
                      @change="getgetTradeTrends()"
                    />
                    <span class="font16 margin-left15 margin-right15">To</span>
                    <el-date-picker
                      class="trade_date_picker"
                      v-model="endDate"
                      type="month"
                      :placeholder="$t('SearchTrade.Enddate')"
                      value-format="yyyy-MM"
                      :picker-options="endPickerOptions"
                      @change="getgetTradeTrends()"
                    /> 
                  </div>
                  <div class="margin-top30">
                    <div
                      ref="SupplyChainEchart"
                      style="width: 100%; height: 33rem"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <detailecomparePrioduct
      :compareList="compareList"
      v-show="Compare"
      @CompareShowfalse="CompareShowfalse"
    ></detailecomparePrioduct>

    <Login :loginAndCreatePop.sync="loginDialog"></Login>
  </div>
  <!--srcviewscompanylistriskvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import draggable from "vuedraggable";
import { getTypeProductPageList, getTradeTrends } from "@/api/companyApi.js";
import detailecomparePrioduct from "../detailecomparePrioduct.vue";
import { formatNum } from "@/views/company/details/Background/utils";

import Login from "@/components/login.vue";

import {
  getsearchExport,
  getHuokePartPrivilege,
  searchMoreEmail,
} from "@/api/companyApi.js";
import { mixins1 } from "@/mixins/index";
export default {
  name: "",

  mixins: [mixins1],
  components: {
    draggable,
    Login,
    detailecomparePrioduct,
  },
  watch: {
    isOpenSlct: {
      handler(newVal, oldVal) {
        this.isOpenSlct = newVal;
        this.CompanyList.map((item) => {
          item.isChecked = false;
        });
        this.changeItemChecked();
        // 在这里处理columns属性的变化

        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Compare: {
      handler(newVal, oldVal) {},

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  data() {
    return {
      PCMoudele: [],
      Compare: false,
      isOpenSlct: false,
      LastUpdate: "",
      datePicker: ["2025-01", "2025-12"],
      loginDialog: false,
      supplierNamevalue: "",
      supplierNameList: [],
      Improtradio: "",
      buyerNameList: [],
      buyerNamevalue: "",
      isShowTooltip: false,
      RiskLoding: false,
      MainProductsShow: "",
      json_fields: {
        companyTag: "companyTag",
        department: "department",
        email: "email",
        name: "name",
        phone: "phone",
        position: "position",
        linkedin: "linkedin",
      },
      json_fieldsImport: {
        Date: "ie_date",
        Products: "hscode_description_inter",
        "Buyer Names": "import_name",
        Destination: "import_country_inter",
        "Supplier Names": "export_name",
        Origin: "export_country_inter",
        Amount: "amount",
      },
      menuActive: 1,
      importGrowthRateTrendList: [],
      importTrendListEcharts: [],

      compareList: [],
      totle: 0,
      checked: "",
      pageNo: 1,
      disabled: false,
      NationalIndustryActive: "null",
      isRotated: false,

      NationalIndustryShow: false,

      isOpenSlct: false,

      checkList: [],
      aaaid: "",

      CompanyList: [],

      token: localStorage.getItem("token"),
      Saved: undefined,
      isChecked: "",
      DetailsFormImportlist: [],
      riskTotal: "",
      QuestionPageList: [],

      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      chageItIndex: 0,
      chageItTrue: false,

        beginDate: "",
      endDate: "",
        beginPickerOptions: {
        disabledDate: (time) => {
          if (!this.endDate) return false
          return time.getTime() > new Date(this.endDate).getTime()
        }
      },

      endPickerOptions: {
        disabledDate: (time) => {
          if (!this.beginDate) return false
          return time.getTime() < new Date(this.beginDate).getTime()
        }
      },
    };
  },
  methods: {
    GotoProducts(item) {
      let routeData = this.$router.resolve({
        path:
          "/index/TradeProduct/TradeDetail/" +
          item.hsCode +
          "/tradeMap/map?id3a=" +
          item.hsCode +
          "&Tradechannel=HsCode" +
          "&Moudles=Trade",
      });
      window.open(routeData.href, "_blank");
    },
    ShowAll() {
      this.page.pageSize = this.page.pageSize + 10;
      this.getSearchList();
    },
    CompareShowfalse(value) {
      this.Compare = value;
    },
    
    
    suppleEchart() {
      let that = this;

      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          left: "0%", // 设置左侧边距
          right: "0%",
          top: "15%",
          bottom: "0%",
          containLabel: true,
        },
        legend: {
          left: "0px",
          top: "0px",
          //  width: '200px'
          // 其他图例配置项
          // ...
        },
        xAxis: {
          type: "category",
          data: that.importTrendListEcharts.map((item) => item.impYearMonth),
          axisTick: {
            show: false, // 不显示 x 轴上的间隔点
          },
          axisLabel: {
            rotate: -60, // 旋转角度设置为 45 度
          },
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
            formatter: function (value) {
                return  formatNum(value) ; // 格式化为千分位
              },              color: "#009EA7", // 这里设置颜色，比如红色
            },
          },
          {
            type: "value",
            position: "right",
            alignTicks: true,
            min: -100,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: "{value}%",
              color: "#FF7600", // 这里设置颜色，比如红色
            },
          },
        ],
        series: [
          {
            name: this.$t("SearchTrade.TradeVolume"),
            type: "bar",
            barWidth: "20",
            itemStyle: { color: "#009EA7" },
            emphasis: {
              itemStyle: {
                color: "#009EA7",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return "USD " +  formatNum(value) ;
                } else {
                  return "-";
                }
              },
            },
            data: that.importTrendListEcharts.map((item) => item.amount),
          },
          {
            name: this.$t("SearchTrade.MonthonMonthRatio"),
            type: "line",
            barWidth: "20",
            yAxisIndex: 1,
            itemStyle: { color: "#FF7600" },
            emphasis: {
              itemStyle: {
                color: "#FF7600",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return value + "%";
                } else {
                  return "-";
                }
              },
            },
            data: that.importTrendListEcharts.map((item) => item.growthRate),
          },
        ],
      };
      this.echartsBox.setOption(option);
      this.$nextTick(() => {
        this.echartsBox.resize();
      });
    },
    clearAllTags() {},
    MenuClick(item) {
      this.menuActive = item.value;
    },

    // 点击列表出现右侧数据
    // 计算右侧图表的 marginTop 值
    calculateMarginTop() {
      if (
        this.NationalIndustryActive === "null" ||
        this.NationalIndustryActive === null
      ) {
        return 0;
      }
      // 使用 Vue 的 refs 来获取元素（如果可能的话）
      const listContainer = document.querySelector(".risk-center-list ul");
      const listItems = document.querySelectorAll(".conpany-center-list");

      if (
        listItems.length > 0 &&
        this.NationalIndustryActive < listItems.length
      ) {
        const targetItem = listItems[this.NationalIndustryActive];

        if (targetItem && listContainer) {
          // 计算目标元素相对于列表容器的偏移量
          const containerRect = listContainer.getBoundingClientRect();
          const itemRect = targetItem.getBoundingClientRect();

          // 返回相对于容器顶部的偏移量
          return itemRect.top - containerRect.top;
        }
      }

      // 如果在 nextTick 之外执行，返回默认值
      // 实际的计算将在 nextTick 中完成
    },

    // 修改 NationalIndustry 方法以触发重新计算
    NationalIndustry(item, index) {
      console.log(114514);
      console.log(item);
      this.beginDate="";
      this.endDate="";

      this.chageItTrue = true;
      this.NationalIndustryShow = true;
      this.NationalIndustryActive = index;
      this.aaaid = item.hsCode;

      this.$nextTick(() => {
        this.getgetTradeTrends();
        // 强制重新计算样式
        this.$forceUpdate();
      });
    },
    getgetTradeTrends() {
      getTradeTrends({
        startMonth: this.datePicker[0],
        type: this.activeIEports,
        endMonth: this.datePicker[1],
        hsCode: this.aaaid,
      }).then((res) => {
        if (res.code == 200) {
          this.importTrendListEcharts = res.data;

          this.$nextTick(() => {
            this.suppleEchart();
          });
        }
      });
    },
    rifghtUpdate() {
      this.NationalIndustryShow = false;
      this.NationalIndustryActive = "null";
    },
    // echarts监听 浏览器宽度改变 echarts改变

    // 获取权限
    getHuokePartPrivilegeList() {
      getHuokePartPrivilege({
        moduleType: 7,
      }).then((res) => {
        if (res.code == 200) {
          this.PCMoudele = res.data;
        }
      });
    },

    setToolsfalse() {
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });
    },
    // 工具栏高亮控制
    setToolsAcive() {
      this.$store.dispatch("app/setTools", {
        name: "Optimize",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "filter",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });

      //   this.$store.dispatch("app/setTools", "filter",'isActive',false);
    },
    // 收藏

    // 获取列表数据
    getSearchList() {
      this.RiskLoding = true;
      getTypeProductPageList({
        tradeCode: this.$route.query.id3a,
        page: 1,
        pageSize: this.page.pageSize,
      }).then((res) => {
        if (res.code == 200) {
          this.RiskLoding = false;
          this.page.total = res.data.total;
          let parentTable = res.data.rows;
          parentTable.map((item, index) => {
            item.destinationCountryList.map((ite, ind) => {
              let countryImg = this.getCountryImgUrl(ite.countryCode);
              if (countryImg) {
                let flag = require("../../../../../static" + countryImg);
                ite.flag = flag;
              }
            });
            item.originCountryList.map((itetwo, ind) => {
              let countryImgtwo = this.getCountryImgUrl(itetwo.countryCode);
              if (countryImgtwo) {
                let flag = require("../../../../../static" + countryImgtwo);
                itetwo.originflag = flag;
              }
            });
            this.page.total = res.data.total;
            this.refresh++;
          });
          this.CompanyList = parentTable;
        } else {
          this.RiskLoding = false;
        }
      });
      // let parentTable = this.parentTable
      // this.parentTable.map((item, index) => {
      //     let countryImg = this.getCountryImgUrl(item.company_country);
      //     if (countryImg) {
      //         let flag = require("../../../../../static" + countryImg);
      //         parentTable[index].flag = flag;
      //         this.refresh++;
      //     }
      // });

      //
    },
    // 删除元素
    DelClick(item, index) {
      if (this.PCMoudele[13].hasPrivilege) {
        this.deledeLaeadsDialog = true;
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },

    // 移动
    onMove(e) {
      if (e.relatedContext.element.isDing == true) return false;
      return true;
    },

    // 全选操作
    changeItemChecked(value) {
      if (this.CompanyList.filter((item) => item.isChecked).length > 0) {
        this.checked = true;
      } else {
        this.checked = false;
      }

      let selectCompany = this.CompanyList.filter((item) => item.isChecked);
      this.$store.dispatch("app/setchangeList", selectCompany);
      this.compareList = selectCompany;
      // this.$nextTick(() => { });

      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: this.compareList.length > 0 && this.compareList.length < 4,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });
    },
    // 全选操作
    changeSlctAll(value) {
      this.CompanyList.slice(0, 20).forEach((item) => {
        item.isChecked = value;
      });
      let selectCompany = this.CompanyList.slice(0, 20).filter(
        (item) => item.isChecked,
      );
      this.compareList = selectCompany;
      this.$store.dispatch("app/setchangeList", selectCompany);
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "highlight-cell"; // 设置你想要的背景色
      }
    },

    // setTools
    setTools() {
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
    }, // getDetail
  },
  computed: {
     calDate() {
      this.datePicker = [this.beginDate, this.endDate];
      return this.datePicker;
    },
    managementMenu() {
      return [
        {
          label: this.$t("SearchTrade.Suppliers"),
          value: "1",
        },
        {
          label: this.$t("SearchTrade.Buyers"),
          value: "2",
        },
      ];
    },
  },
  created() {
    this.setToolsfalse();
  },
  mounted() {
    //
    this.$emit("UpdatamarkTotalList", true);
    this.getSearchList();
    this.setToolsfalse();
    if (this.token) {
      this.getHuokePartPrivilegeList();
    }
  },
  beforeDestroy() {},
};
</script>
<style scoped>
.operations-head {
  color: #009ea7;
}

.ud6279 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-top: 7.642857142857143rem;
}

.u96d4d {
  width: 29rem;
}

.uba4wV3 {
  margin-right: 1.0714285714285714rem;
  margin-bottom: 0.7142857142857143rem;
  margin-top: 0.7142857142857143rem;
  margin-left: 1.0714285714285714rem;
}

.ub7918 {
  color: #999999;
  /* margin-bottom: 10px; */
  font-size: 1.1428571428571428rem;
  text-align: left;
  font-style: normal;
  overflow: hidden;
}

.uVwoZks {
  width: 100%;
}

.hidemenu {
  display: block;
  width: 0em;
  padding-left: 0em;
  padding-top: 0em;
  padding-bottom: 0em;
  padding-right: 0em;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.tptitleSplit {
  color: #cccccc;
  font-size: 20px;
  line-height: 20px;
  margin: 20px 30px;
}

.scrollbar {
  overflow: hidden;
  /* overflow-y: auto; */
}

.udb507two {
  width: 100%;
}

.risk-right {
  width: 540px;
  padding: 20px;
  background: #ddedee;
  height: 575px;
  border-radius: 10px;
  position: absolute;
  top: 0px;
  right: 0px;
}

.risk-center-list {
  flex: 1;
  width: 49%;
  /* overflow-y: scroll; */
  position: relative;
}

.Upadetime {
  font-size: 1.2857142857142858rem;
  color: #666666;
  margin-right: 2.142857142857143rem;
}

.flex_center_between_box p {
  font-size: 24px;
  color: #1a2332;
  margin-bottom: 15px;
  display: flex;
  align-items: self-start;
}

.risk-right-content {
  padding: 1.4285714285714286rem 0rem;
  border-top: 0.07142857142857142rem solid #cccccc;
  /* border-bottom: 0.07142857142857142rem solid #CCCCCC; */
}

.risk-right-content-title {
  /* font-weight: 400; */
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  height: 1.7142857142857142rem;
  margin-bottom: 1.4285714285714286rem;
  font-family: "Arial Bold";
}

.right-txt {
  text-align: right;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
  line-height: 1.8571428571428572rem;
}

.left-txt {
  font-size: 1.2857142857142858rem;
  color: #666666;
}

.margin16 {
  margin-top: 1.1428571428571428rem;
}

.highlight-cell {
  background-color: #f2f5f9 !important;
}

.risk-right .el-table .cell {
  color: #1a2332;
}

.table-content {
  height: 3.5714285714285716rem !important;
  line-height: 3.5714285714285716rem;
}

.risk-right .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.conpany-center-list {
  padding: 30px 30px 10px 20px;
  background: #f5f5f5;
  border-radius: 10px;
  margin-bottom: 10px;
  overflow-x: hidden;
}

.conpany-center-list-left {
  font-size: 24px;
  color: #1a2332;
  display: flex;
  align-items: flex-start;
}

.conpany-center-list-leftWith {
  max-width: calc(100% - 200px);
}

.risk-center-list .el-checkbox__inner,
.Alchecked .el-checkbox__inner {
  height: 1.4285714285714286rem !important;
  width: 1.4285714285714286rem !important;
}

.conpany-center-list-left .el-checkbox__inner {
  margin-top: 0.2857142857142857rem !important;
}

.risk-center-list .el-checkbox__inner::after,
.Alchecked .el-checkbox__inner::after {
  height: 0.7142857142857143rem;
  left: 0.5rem;
}

.risk-center-list .el-checkbox__input.is-checked .el-checkbox__inner,
.Alchecked .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #8e86dd;
  border-color: #8e86dd;
}

.risk-center-list .el-checkbox__input.is-focus .el-checkbox__inner,
.Alchecked .el-checkbox__input.is-focus .el-checkbox__inner,
.Alchecked
  .el-checkbox__inner:hover
  .risk-center-list
  .el-checkbox__inner:hover {
  border: 0.07142857142857142rem solid #dcdfe6;
}

.risk-center-list .el-checkbox__input.is-checked + .el-checkbox__label,
.Alchecked .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #1a2332;
}

.indexPositon {
  margin-right: 1.4285714285714286rem;
  color: #009ea7;
  width: 1.4285714285714286rem;
}

.indexPositonactive {
  color: #999999;
  min-width: 30px;
  height: 30px;
  font-family: "Arial Bold";
}

.list-text-color {
  font-size: 18px !important;
  color: #666666 !important;
  display: flex;
  align-items: center;
}

.list-text-color span {
  color: #1a2332;
  margin-right: 20px;
}
.list-text-color span .CodeMargin {
  color: #1a2332;
  margin-right: 10px;
}

.overexperise {
  /* max-width: 60%; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: fit-content;
}
.Priduct_Name {
  /* max-width:75%; */
}
.marginbottom500 {
  margin-bottom: 500px;
}
.product_title{
  font-size: 16px;
}
@media screen and (max-width: 1920px) {
  .conpany-center-list-leftWith {
    max-width: calc(100% - 160px);
  }
  .Priduct_Name,
  .overexperise {
    max-width: 100% !important;
  }
}
@media screen and (max-width: 1439px) {
  .Priduct_Name,
  .conpany-center-list-leftWith {
    max-width: calc(100% - 150px);
  }
  .overexperise {
    max-width: 100% !important;
  }
}
.list-text-color img,
.contry_img {
  width: 60px;
  height: 40px;
  padding: 5px;
}

.margin20 {
  margin-left: 1.4285714285714286rem;
}

.iconbg {
  width: 50px;
  height: 50px;
  background: #ddedee;
  border-radius: 50%;
  cursor: pointer;
}

.conpany-center-list-right p {
  justify-content: flex-end;
  margin-bottom: 0px;
}

.bottom-list-echarts {
  padding-left: 2.8142857142857144rem;
  display: flex;
  justify-content: space-between;
}

.bottom-list-echarts-li {
  padding: 1.4285714285714286rem;
  background: #f5f5f5;
  height: 18.571428571428573rem;
  /* flex: 1; */
  width: 33%;
  padding-bottom: 0.7142857142857143rem;
}

.icontransform {
  display: inline-block;
  transition: transform 0.5s ease;
  /* 设置过渡效果 */
  cursor: pointer;
}

.rotate {
  transform: rotate(-180deg);
  /* 旋转180度 */
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active 在 Vue 2.x 中 */ {
  opacity: 0;
  /* 初始透明度 */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
  /* 淡入淡出动画 */
}

.left_menu_title {
  font-size: 1.7142857142857142rem;
  color: #1a2332;
  margin: 1.4285714285714286rem 0rem;
  padding-bottom: 10px;
  border-bottom: 1px solid #dddddd;
  font-family: "Arial Bold";
}

.left_menu_question p {
  font-size: 1.28571428571428rem;
  color: #1a2332;
  margin-bottom: 1.0714285714285714rem;
  font-family: "Arial Bold";
}

.left_menu_question /deep/ .el-select .el-input__suffix {
  display: none;
}

.left_menu_question .el-input__inner {
  height: 2.5714285714285716rem;
  background: #ffffff;
  border-radius: 10px;
  font-size: 1.1428571428571428rem;
  color: #1a2332;
  padding-left: 0.7142857142857143rem !important;
}

.left_menu_question /deep/ .el-select .el-input.is-focus .el-input__inner,
.left_menu_question /deep/ .el-select .el-input__inner:focus {
  border: 0.07142857142857142rem solid #cccccc !important;

  line-height: 2.428571rem !important;
}

.left_menu_question {
  margin-bottom: 0.7142857142857143rem;
  padding-bottom: 1.4285714285714286rem;
}

.FilterQuestion .left_menu_question {
  padding-bottom: 0rem;
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #f5f5f5;
  border-color: #cccccc;
  color: #999999;
  line-height: 2.428571rem !important;
}

.left_menu_bottom {
  font-size: 1.1428571428571428rem;
  color: #1a2332;
  margin-bottom: 3rem;
}

.profit-txt {
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.color1290C9 {
  text-align: right;
}

.question-detail_cont-list h3 {
  margin-top: 0.7142857142857143rem;
  font-family: "Arial";
  font-weight: 400;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
  /* height: 1.7142857142857142rem; */
  /* line-height: 1.7142857142857142rem; */
}

button:disabled {
  cursor: no-drop !important;
}

.el-popover {
  padding: 10px !important;
  min-width: auto;
}

.uedbd2 {
  height: 100%;
  display: flex;
  background: #f5f5f5;
  border-radius: 10px;
}

.right_cont_box {
  height: 100%;
  overflow-y: auto;
}

.IElabel {
  font-size: 16px;
  color: #ff7600;
  text-align: center;
  background: #fff8f1;
  line-height: 26px;
  width: 70px;
  border-radius: 15px;
  border: 1px solid #ff7600;
}

.IElabelExport {
  background: #f4fbff;
  border-radius: 15px;
  border: 1px solid #1290c9;
  color: #1290c9;
}

.left_menu_context-title {
  font-size: 18px;
  color: #1a2332;
  font-family: "Arial Bold";
  margin-bottom: 20px;
  position: relative;
}

.left_menu_context {
  margin-bottom: 30px;
}

.left_menu_context /deep/ .el-input__inner {
  height: 36px !important;
}

/deep/ .el-radio {
  justify-content: flex-start;
  font-size: 1.1428575rem;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #009ea7;
  font-size: 1.1428575rem;
}

/deep/ .el-radio__label {
  font-size: 1.1428575rem;
  color: #1a2332;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #009ea7;
  background: #fff;
}

/deep/ .el-radio__input.is-checked .el-radio__inner::after {
  background: #009ea7;
}

.Clear_all {
  position: absolute;
  right: 0px;
  font-size: 16px;
  z-index: 999;
  cursor: pointer;
}

.MainProducts {
  background: #f5f5f5;
  border-radius: 5px;
  border: 1px solid #009ea7;
  padding: 5px;
  margin-bottom: 5px;
  font-size: 16px;
  color: #009ea7;
  display: inline-block;
}

.MainProductsAll {
  width: 30px;
  height: 30px;
  background: #ddedee;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  color: #009ea7;
  cursor: pointer;
}

.MainProductsMainProducts {
  width: 80%;
  height: 30px;
  overflow: hidden;
}

.iconbgActiveBG {
  background: #ddedee;
}

.iconbgActiveBG .iconbgActive {
  background: #009ea7;
}

.iconbgActiveBG {
  margin-right: 0px;
  border-radius: 5px;
}
/deep/ .el-date-editor .el-range__close-icon {
  display: none !important;
}
.productsNameActive:hover {
  text-decoration-line: underline;
  color: #009ea7;
  cursor: pointer;
}
.productInfp {
  width: calc(100% - 100px);
}
.productTitle {
  width: 100%;

  min-height: 34px;
}
.icon-dianhuaheshi {
  font-size: 26px;
}
.icon-gongyinglianyunyingnengli  {
  font-size: 22px;
}
.icon-qushi {
  font-size: 28px;
}
.Lmargin {
  margin-left: 15px;
}
.flagDiv {
  min-width: 300px;
}
.detailcontent {
  max-width: calc(100% - 40px);
}
.detailcontent1 {
  max-width: calc(100% - 400px);
}
.trade_date_picker {
  height: 36px !important;
  font-size: 16px;
}
.trade_date_picker {
  width: 200px;
}
@media (max-width: 1920px) {
  .productTitle {
    min-height: 26px;
  }
  .conpany-center-list {
    padding: 23px 23px 8px 15px;
    background: #f5f5f5;
    margin-bottom: 8px;
    overflow-x: hidden;
  }
  .list-text-color span {
    color: #1a2332;
    margin-right: 15px;
  }
  .indexPositonactive {
    min-width: 23x;
    height: 23px;
  }
  .conpany-center-list-left {
    font-size: 18px;
  }

  .flex_center_between_box p {
    font-size: 18px;
    color: #1a2332;
    margin-bottom: 11px;
    display: flex;
    align-items: self-start;
  }
  .list-text-color {
    font-size: 16px !important;
    color: #666666 !important;
    display: flex;
    align-items: center;
  }
  .list-text-color img,
  .contry_img {
    width: 45px;
    height: 30px;
    padding: 4px;
  }
  .icon-dianhuaheshi {
    font-size: 24px;
  }
  .icon-gongyinglianyunyingnengli  {
    font-size: 20px;
  }
  .icon-qushi {
    font-size: 26px;
  }
  .Lmargin {
    margin-left: 11px;
  }

  .tptitleSplit {
    font-size: 20px;
    line-height: 20px;
    margin: 10px 23px;
  }
  .iconbgActiveBG {
    background: #ddedee;
    margin-right: 0px;
  }
  .flagDiv {
    min-width: 225px;
  }
  .left_menu_context-title {
    font-size: 16px;
    margin-bottom: 7px;
  }
  .Clear_all {
    font-size: 14px;
  }
  .left_menu_context {
    margin-bottom: 22px;
  }
  .iconbg {
    width: 37px;
    height: 37px;
  }
  .risk-right {
    height: 592px;
  }
  .trade_date_picker {
    height: 32px !important;
    font-size: 14px;
  }
  .trade_date_picker {
    width: 150px;
  }
}
@media screen and (max-width: 1439px) {
  .productTitle {
    min-height: 23px;
  }
  .conpany-center-list {
    padding: 20px 20px 7px 13px;
    background: #f5f5f5;
    margin-bottom: 7px;
    overflow-x: hidden;
  }
  .list-text-color span {
    color: #1a2332;
    margin-right: 13px;
  }
  .indexPositonactive {
    min-width: 20x;
    height: 20px;
  }
  .conpany-center-list-left {
    font-size: 16px;
  }

  .flex_center_between_box p {
    font-size: 16px;
    color: #1a2332;
    margin-bottom: 10px;
    display: flex;
    align-items: self-start;
  }
  .list-text-color {
    font-size: 12px !important;
    color: #666666 !important;
    display: flex;
    align-items: center;
  }
  .list-text-color img,
  .contry_img {
    width: 40px;
    height: 26px;
    padding: 3px;
  }
  .icon-dianhuaheshi {
    font-size: 20px;
  }
  .icon-gongyinglianyunyingnengli  {
    font-size: 18px;
  }
  .icon-qushi {
    font-size: 22px;
  }
  .Lmargin {
    margin-left: 10px;
  }
  .tptitleSplit {
    font-size: 20px;
    margin: 20px;
  }
  .iconbgActiveBG {
    margin-right: 0px;
    background: #ddedee;
  }
  .flagDiv {
    min-width: 202px;
  }
  .left_menu_context-title {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .Clear_all {
    font-size: 12px;
  }
  .left_menu_context {
    margin-bottom: 20px;
  }
  .iconbg {
    width: 33px;
    height: 33px;
  }
  .risk-right {
    height: 643px;
  }
}
</style>
